<hr />
<div class="row my-2">
  <div class="col-sm-4">
    <h6>
      <img
        class="p-2"
        ngSrc="assets/images/icons/envasado.svg"
        alt="Vehículos"
        height="50"
        width="50"
      />Vehículos
    </h6>
  </div>
  <div class="col-sm-8 text-end">
    <div class="input-search-container-new">
      <span class="material-symbols-outlined search-icon"> search </span>
      <input
        placeholder="Buscar"
        class="input-search-datatable"
        id="custom-search-input"
        type="text"
        [(ngModel)]="searchText"
        (input)="applyFilter()"
      />
    </div>
    <button
      id="vehicles-list-new"
      class="btn-btn-create"
      (click)="onNewVehicle()"
      *ngIf="showButton('create')"
    >
      Crear Vehículo
    </button>
    <button
      id="vehicles-list-refresh"
      class="btn mx-2 btn-refresh"
      (click)="onRefresh()"
    >
      <span class="material-symbols-outlined"> refresh </span>
    </button>
  </div>
</div>
<div class="row">
  <div class="text-center my-5" *ngIf="isGettingVehicles">
    <app-spinner message="Cargando vehículos"></app-spinner>
  </div>
  <div class="col-xs-12">
    <div class="table-responsive-sm" *ngIf="!isGettingVehicles">
      <table
        datatable
        [dtOptions]="dtOptions"
        class="table display nowrap"
        style="width: 100%"
      >
        <caption>
          Lista de Vehículos
        </caption>
        <thead>
          <tr class="text-center">
            <th
              scope="col"
              *ngFor="let attribute of vehiclesAttributes"
              [hidden]="hideColumn(attribute)"
            >
              {{ attribute }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vehicle of vehicles">
            <td>
              <a
                id="vehicles-list-{{ vehicle.licensePlate }}"
                (click)="onSelectedVehicle(vehicle)"
                style="color: #0d6efd"
                >{{ vehicle.sapId! | sapId }}</a
              >
            </td>
            <td>
              <span>
                <img
                  [ngSrc]="getImageSrc(vehicle.status)"
                  height="25"
                  width="25"
                  alt="Estado"
                />
              </span>
              {{ vehicle.status | master : "VEHICLES#STATUSES" }}
            </td>
            <td>{{ vehicle.licensePlate }}</td>
            <td [hidden]="hideColumn('Transportista')">
              {{ vehicle.carrier!.name }}
            </td>
            <td>{{ vehicle.center | master : "CENTERS" }}</td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasToExpireDocuments(vehicle)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  vehicle.documentsToExpire
                }}</span>
                Por vencer</span
              >
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasExpiredDocuments(vehicle)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  vehicle.documentsExpired
                }}</span>
                Vencido</span
              >
            </td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngFor="let blockingMotive of vehicle.blockingMotives"
              >
                {{ blockingMotive }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
